package org.dronda.lib.validation.rules

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import org.dronda.lib.validation.ValidationError

private val dateRegex = """^([0-9]{4})-?(1[0-2]|0[1-9])-?(3[01]|0[1-9]|[12][0-9])${'$'}""".toRegex()

data class InvalidDate(val value: String) : ValidationError()

fun date(value: String): Result<String, ValidationError> {
    return if (dateRegex.matches(value)) {
        Ok(value)
    } else {
        Err(InvalidDate(value))
    }
}